// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_body__mgmV6 {
    min-height: 100vh;
    width: 100%;
}

.dashboard_content__8tRJh {
    width: 100%;
    padding-bottom: calc(40px + constant(safe-area-inset-bottom, 0px));
    padding-bottom: calc(40px + env(safe-area-inset-bottom, 0px));
}
`, "",{"version":3,"sources":["webpack://./src/layout/dashboard.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kEAAkE;IAClE,6DAA6D;AACjE","sourcesContent":[".body {\n    min-height: 100vh;\n    width: 100%;\n}\n\n.content {\n    width: 100%;\n    padding-bottom: calc(40px + constant(safe-area-inset-bottom, 0px));\n    padding-bottom: calc(40px + env(safe-area-inset-bottom, 0px));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `dashboard_body__mgmV6`,
	"content": `dashboard_content__8tRJh`
};
export default ___CSS_LOADER_EXPORT___;
